import {
  mapGetters,
  mapMutations,
} from 'vuex';

import SummerTiresIcon from '@/assets/images/icons/summer-tires.svg';
import WinterTiresIcon from '@/assets/images/icons/winter-tires.svg';
import AllSeasonTiresIcon from '@/assets/images/icons/all-season-tires.svg';

export default {
  name: 'TireTypePicker',
  components: {
    SummerTiresIcon,
    WinterTiresIcon,
    AllSeasonTiresIcon,
  },
  props: {
    title: '',
    type: '',
  },
  data: () => ({

  }),
  computed: {
    ...mapGetters('appointment', {
      tireType: 'getTireType',
      tireStock: 'getTireStock',
      vehiculeType: 'getVehiculeType',
      serviceType: 'getServiceType',
      customerDataRaw: 'getCustomerDataRaw',
    }),
    hasNoStock() {
      return this.tireStock.tz === 0 && this.tireStock.ms === 0 && this.tireStock.ts === 0;
    },
  },
  methods: {
    ...mapMutations('appointment', {
      setTireTypeMutation: 'SET_TIRETYPE',
    }),
    setTireType(tireType) {
      if (!this.isDisabled(tireType) && !this.isDisabledLeaseFleetOnNewTires(tireType)) {
        this.setTireTypeMutation({ tireType: tireType, changeTireType: false });
      }
    },
    isDisabled(data) {
      // console.log(this.type);
      return (this.tireStock[data] === 0 && !this.hasNoStock) || this.type === 'tpp';
    },
    isDisabledLeaseFleetOnNewTires(type) {
      // Dus hebben ze zomerbanden op de wagen liggen => dan zomer en 4 seizoensbanden
      // Hebben we winterbanden op de wagen liggen => dan winter of 4 seizoensbanden
      // Hebben ze 4 seizoensbanden op de wagen liggen dan mogen ze alle drie kiezen.

      // In de case van lease/fleet + new-tires hebben we de stock gecleared -> kijken naar customerdata raw
      const summerTiresOnCar = this.customerDataRaw.tires.filter(t => t.tireType === 'TZ' && t.stock === false).length;
      const winterTiresOnCar = this.customerDataRaw.tires.filter(t => t.tireType === 'MS' && t.stock === false).length;
      const seasonTiresOnCar = this.customerDataRaw.tires.filter(t => t.tireType === 'TS' && t.stock === false).length;

      if ((this.vehiculeType === 'lease' || this.vehiculeType === 'fleet') && this.serviceType === 'new-tires') {
        if (seasonTiresOnCar > 0) {
          return false;
        }

        if (summerTiresOnCar > 0 && type === 'ms') {
          return true;
        }

        if (winterTiresOnCar > 0 && type === 'tz') {
          return true;
        }

        return false;
      }

      return false;
    },
  },
};
